import type { KNUser } from 'context/authentication/UserContext.types'

export const getEnv = (): string => import.meta.env.VITE_API_ENV

export const isProd = (): boolean => getEnv() === 'prod'

export const getBaseUrl = (): string => {
  const host = globalThis.location.hostname
  if (host === 'localhost') {
    return 'http://localhost:3000'
  } else if (host.includes('cn.')) {
    return import.meta.env.VITE_CS_DOMAIN_CN
  }
  return import.meta.env.VITE_CS_DOMAIN
}

export const getBaseApiUrl = (): string => {
  if (globalThis.location.hostname === 'localhost' && import.meta.env.VITE_PROXY_OPT_IN) {
    return ''
  }

  return globalThis.location.hostname.includes('cn.')
    ? import.meta.env.VITE_API_URL_CN
    : import.meta.env.VITE_API_URL
}

export const isSentryEnabled = (): boolean => {
  if (globalThis.location.hostname === 'localhost') {
    return false
  }
  if (!import.meta.env.VITE_SENTRY_DSN) {
    return false
  }
  if (!import.meta.env.VITE_API_ENV) {
    return false
  }
  return true
}

export const isSupportUser = (user?: KNUser): boolean => {
  if (!user) {
    return false
  }
  const supportEmails = [
    'sandra.vasic@kuehne-nagel.com',
    'ivana.cvetkovic@kuehne-nagel.com',
    'milica.d.panic@kuehne-nagel.com',
    'jelena.drobnjak@kuehne-nagel.com',
  ]
  return supportEmails.includes(user.email)
}
